export default __webpack_public_path__ + "media/src/features/listing-agent-match-on-hdp/assets/agentIcon-ae19e958f4a7beab27d987a3a00c795b.svg";